// import { login, logout, getInfo } from '@/api/user'
import { getRequest } from '../../utils/utils'
const getDefaultState = () => {
  return {

    userBase: null
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },

  SET_USER: (state, user) => {
    state.userBase = user
  }
}

const actions = {

  // user logout
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_USER', null)
      resolve()
    })
  },
  login ({ commit }, userBase) {
    return new Promise((resolve, reject) => {
      commit('SET_USER', userBase)
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js